import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";

export default function SubmittedPage() {
  return (
    <div className="min-h-screen bg-[#fbfdfc] flex flex-col">
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-3xl mx-auto px-4 py-4">
          <Logo size={42} />
        </div>
      </header>
      <main className="flex-1 flex items-center justify-center px-4">
        <div className="text-center max-w-md animate-fade-in-up">
          <div className="mx-auto h-20 w-20 rounded-full bg-brand-100 text-brand-700 grid place-items-center mb-6">
            <CheckCircle2 size={40} />
          </div>
          <h1
            data-testid="submitted-heading"
            className="font-heading text-3xl font-semibold text-ink-900"
          >
            Application received!
          </h1>
          <p className="mt-3 text-ink-700">
            Thank you for applying with Tulsi Jobs. Our placement team will review
            your details and reach out shortly with matching opportunities.
          </p>
          <Link to="/apply">
            <Button
              variant="outline"
              data-testid="submit-another-btn"
              className="mt-6 border-brand-200 text-brand-700 hover:bg-brand-50"
            >
              Submit another application
            </Button>
          </Link>
        </div>
      </main>
      <footer className="text-center text-xs text-ink-600 py-8">
        © {new Date().getFullYear()} Tulsi Jobs Placement Consultant
      </footer>
    </div>
  );
}
